'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.devicecert.edit', [])
  .controller('DeviceCertEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/devicecert/edit/index.js